<template>
    <div>
        <h1>Credits</h1>

        <p>Crédits : {{credit}}</p>

        <p>Ajouter ou enlever <b-input type="number" v-model="add_credit" /></p>

        <b-button @click="add">Ajouter</b-button>

		<p>
			<b-button
				v-if="if_prev"
				v-on:click="
					page -= 1;
					onSubmit();
				"
				variant="primary"
				><i class="fas fa-arrow-circle-left"></i
			></b-button>
			Page {{ page + 1 }}
			<b-button
				v-if="if_next"
				v-on:click="
					page += 1;
					onSubmit();
				"
				variant="primary"
				><i class="fas fa-arrow-circle-right"></i
			></b-button>
		</p>

        <b-table
			striped
			hover
			:items="history"
			:fields="fields"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
        >
        </b-table>
    </div>

</template>

<script>
	import store from "../store.js";

	import service_clients from "../services/client.js";
	import users from "../services/users.js";

	export default {
		name: "admin_credits",
        components: {
        },
		data: function () {
			return {
				page: 0,
				if_prev: false,
				if_next: false,
                credit: 0,
                add_credit: 0,
                client: {},
                history: [],
				sortBy: "date",
				sortDesc: true,
                fields: [{
						key: "value",
						label: "Opérations",
						sortable: false,
					},{
						key: "date",
						label: "Date",
						sortable: true,
					},{
						key: "details",
						label: "Détails",
						sortable: true,
					},{
						key: "client_user_uid",
						label: "Utilisateur",
						sortable: true,
					}]
			};
		},
		methods: {
			onSubmit: async function (reset = false) {
				if (reset) 
					this.page = 0;
				if (this.page < 0) 
					this.page = 0;
				await this.get_history(this.page);
				if (this.page == 0) 
					this.if_prev = false;
				else 
					this.if_prev = true;
				console.log(this.history.length)
				if (this.history.length < 10) 
					this.if_next = false;
				else 
					this.if_next = true;
			},
			async get_history(page)
			{
				this.history = await service_clients.creditHistory(page);
				console.log(this.history)
			},
            async add()
            {
                await service_clients.addCredit(this.client.uid, parseFloat(this.add_credit))

                let response = await users.getSelf(true);
                this.client = response.client;
                
                this.credit = this.client.credits;
                this.add_credit = 0;

                this.onSubmit();
            },
            isAdmin: function() {
                return store.getters.isAdmin;
			},
		},
		mounted: async function () {
			
			if (!this.isAdmin())
			{
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
            this.client = response.client;
            
            this.credit = this.client.credits;

			await this.onSubmit();

		},
	};
</script>
